"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// avoid "reverse" array method as it changes in place
// we need to create a new reversed list instead
var reverseList = function (list) {
    return list.map(function (item, i, l) { return l[l.length - (i + 1)]; });
};
exports.default = reverseList;
//# sourceMappingURL=reverseList.js.map